module.exports = __webpack_public_path__ + "static/media/9.7f7752dc.png";